import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("heatmapReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	heatmaps: null,
	picklists: null,
	lastUpdated: null
});

function heatmapReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset heatmap state");
			return initialState;
		}
		case actionTypes.HEATMAP_LOADED: {
			const loadedHeatmap = action.data;
			let {heatmaps} = state;
			const index = (heatmaps || []).findIndex(h => h.Id === loadedHeatmap.Id);

			if(index > -1) {
				heatmaps[index] = loadedHeatmap;
			}
			else {
				heatmaps = [loadedHeatmap];
			}

			return {
				...state,
				heatmaps
			};
		}
		case actionTypes.HEATMAPS_LOADED: {
			return {
				...state,
				heatmaps: action.data,
				lastUpdated: action.lastUpdated
			};
		}
		case actionTypes.HEATMAP_PICKLISTS_LOADED: {
			return {
				...state,
				picklists: action.data
			};
		}
		default:
			return state;
	}
}

export default heatmapReducer;
